// @ts-strict-ignore
import React from 'react';
import { Inline } from '@styleseat/ui';
import {
  BodyText,
  Button,
  HeaderText,
  Stack,
} from '../../../ui';

export const JoinEntryHeader = ({
  testID,
  onClick,
  isMobileOrTablet,
  breakpoints,
  titleAlignmentBreak,
  isIpadWidthOrLess,
  deviceWidth,
}) => {
  const title = 'Set up your business on StyleSeat';

  let width;
  if (titleAlignmentBreak) {
    width = '100%';
  } else if ((breakpoints?.tablet || breakpoints?.desktopNarrow) && deviceWidth > 430) {
    width = '64%';
  } else if (breakpoints?.mobile || deviceWidth <= 430) {
    width = '100%';
  } else {
    width = '72%';
  }
  return (
    <Stack
      space={12}
      testID={`${testID}-stack`}
      paddingTop={breakpoints.mobile || deviceWidth <= 430 ? 0 : 40}
      width={width}
      paddingX={breakpoints.mobile || deviceWidth <= 430 ? '4%' : 0}
      paddingLeft={deviceWidth >= 1120 && deviceWidth < 1207 ? '20%' : undefined}
    >
      <HeaderText
        fontSize={!isIpadWidthOrLess ? 36 : undefined}
        level={1}
        textAlign="center"
        testID={`${testID}-title`}
      >
        {title}
      </HeaderText>
      <BodyText appearance="large" textAlign="center" testID={`${testID}-description`}>
        Join the largest network of clients searching for top professionals.
      </BodyText>
      <Inline
        paddingTop={!isMobileOrTablet ? 10 : 20}
        alignItems="center"
        justifyContent="center"
        width="100%"
      >
        <Button
          appearance="primary"
          size="large"
          onClick={onClick}
          style={{
            lineHeight: '32px',
          }}
        >
          Learn More
        </Button>
      </Inline>
    </Stack>
  );
};
